var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9166 18.4167V23.75C26.9166 26.5784 26.9166 27.9926 26.038 28.8713C25.1593 29.75 23.7451 29.75 20.9166 29.75H13.0833C10.2549 29.75 8.84067 29.75 7.96199 28.8713C7.08331 27.9926 7.08331 26.5784 7.08331 23.75V10.25C7.08331 7.42157 7.08331 6.00736 7.96199 5.12868C8.84067 4.25 10.2549 4.25 13.0833 4.25H17",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 4.25L25.5 12.75",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 8.5L21.25 8.5",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18.4167L21.25 18.4167",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75L18.4167 12.75",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 24.0833L18.4167 24.0833",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.bfe6981352b4d7a0aa602b9b4da39095.svg";
export { ForwardRef as ReactComponent };